module.exports = __webpack_public_path__ + "img/home-shortcuts.44d8e575.png";